module.exports = __webpack_public_path__ + "static/media/red-user.0ad8e4cb.svg";